// collectionOperationDashboard/utils/brazilMap.js

// 巴西各州简写与名称映射
export const ibgeToUf = {
  11: 'RO',
  12: 'AC',
  13: 'AM',
  14: 'RR',
  15: 'PA',
  16: 'AP',
  17: 'TO',
  21: 'MA',
  22: 'PI',
  23: 'CE',
  24: 'RN',
  25: 'PB',
  26: 'PE',
  27: 'AL',
  28: 'SE',
  29: 'BA',
  31: 'MG',
  32: 'ES',
  33: 'RJ',
  35: 'SP',
  41: 'PR',
  42: 'SC',
  43: 'RS',
  50: 'MS',
  51: 'MT',
  52: 'GO',
  53: 'DF'
};

// 无独立客户桶的客户（Kwai 等）统一归入 OTHER，未收录平台沿用该颜色
export const otherPlatformColor = '#98a2b3';

// 平台名称与颜色（2026-10-20 产品口径：客户只四桶，OTHER 不再返回/展示）
export const platformNames = ['SHEIN', 'TEMU', 'TikTok', 'B2C'];
export const platformColors = ['#079455', '#2f6fed', '#6941c6', '#f79009'];

// 接口 platform 值与前端展示名的映射（后端返回 TKTOK，前端统一展示 TikTok）
const platformAliases = {
  TIKTOK: 'TikTok',
  TKTOK: 'TikTok',
  KWAI: 'OTHER',
  OUTROS: 'OTHER',
  OUTRAS: 'OTHER'
};

// 归一化平台名：TKTOK/TIKTOK → TikTok，Kwai/空值 → OTHER
export function normalizePlatform(name) {
  if (name === null || name === undefined || name === '') return 'OTHER';
  const raw = String(name).trim();
  return platformAliases[raw.toUpperCase()] || raw;
}

// 平台对应颜色，未收录的平台统一用 OTHER 色
export function platformColorOf(name) {
  const index = platformNames.indexOf(normalizePlatform(name));
  return index > -1 ? platformColors[index] : otherPlatformColor;
}

// 各州数据（州代码, 订单量, 各平台占比）
export const stateProfiles = {
  AC: { orders: 980, platforms: [0.54, 0.17, 0.14, 0.15] },
  AL: { orders: 2180, platforms: [0.49, 0.21, 0.16, 0.14] },
  AP: { orders: 860, platforms: [0.47, 0.18, 0.17, 0.18] },
  AM: { orders: 4120, platforms: [0.5, 0.19, 0.14, 0.17] },
  BA: { orders: 12680, platforms: [0.58, 0.18, 0.13, 0.11] },
  CE: { orders: 7960, platforms: [0.52, 0.23, 0.15, 0.1] },
  DF: { orders: 5680, platforms: [0.55, 0.17, 0.16, 0.12] },
  ES: { orders: 3800, platforms: [0.56, 0.16, 0.13, 0.15] },
  GO: { orders: 9360, platforms: [0.53, 0.21, 0.12, 0.14] },
  MA: { orders: 3220, platforms: [0.48, 0.23, 0.14, 0.15] },
  MT: { orders: 3940, platforms: [0.51, 0.2, 0.14, 0.15] },
  MS: { orders: 3380, platforms: [0.55, 0.18, 0.12, 0.15] },
  MG: { orders: 19680, platforms: [0.62, 0.17, 0.12, 0.09] },
  PA: { orders: 4840, platforms: [0.51, 0.2, 0.13, 0.16] },
  PB: { orders: 2980, platforms: [0.5, 0.21, 0.15, 0.14] },
  PR: { orders: 14420, platforms: [0.6, 0.2, 0.12, 0.08] },
  PE: { orders: 10460, platforms: [0.54, 0.18, 0.17, 0.11] },
  PI: { orders: 2320, platforms: [0.48, 0.22, 0.14, 0.16] },
  RJ: { orders: 28340, platforms: [0.63, 0.15, 0.12, 0.1] },
  RN: { orders: 2680, platforms: [0.5, 0.2, 0.16, 0.14] },
  RS: { orders: 11840, platforms: [0.56, 0.22, 0.13, 0.09] },
  RO: { orders: 1640, platforms: [0.49, 0.2, 0.14, 0.17] },
  RR: { orders: 650, platforms: [0.46, 0.19, 0.15, 0.2] },
  SC: { orders: 8240, platforms: [0.57, 0.21, 0.13, 0.09] },
  SP: { orders: 148920, platforms: [0.62, 0.2, 0.11, 0.07] },
  SE: { orders: 1860, platforms: [0.49, 0.2, 0.15, 0.16] },
  TO: { orders: 1390, platforms: [0.48, 0.21, 0.14, 0.17] }
};

// 各州名称映射
export const stateNames = {
  AC: 'Acre',
  AL: 'Alagoas',
  AP: 'Amapá',
  AM: 'Amazonas',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MT: 'Mato Grosso',
  MS: 'Mato Grosso do Sul',
  MG: 'Minas Gerais',
  PA: 'Pará',
  PB: 'Paraíba',
  PR: 'Paraná',
  PE: 'Pernambuco',
  PI: 'Piauí',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RS: 'Rio Grande do Sul',
  RO: 'Rondônia',
  RR: 'Roraima',
  SC: 'Santa Catarina',
  SP: 'São Paulo',
  SE: 'Sergipe',
  TO: 'Tocantins'
};

// 城市明细数据 [客户, UF, 城市, 揽收总量, 揽收率, MissScan]
export const citiesData = [
  ['SHEIN', 'SP', 'São Paulo', 48240, 0.942, 348],
  ['SHEIN', 'SP', 'Guarulhos', 24760, 0.916, 274],
  ['TEMU', 'SP', 'Campinas', 19680, 0.934, 182],
  ['TikTok', 'SP', 'Osasco', 12420, 0.901, 159],
  ['B2C', 'SP', 'Barueri', 9860, 0.948, 71],
  ['SHEIN', 'SP', 'Santo André', 8780, 0.929, 83],
  ['TEMU', 'SP', 'São Bernardo do Campo', 7940, 0.914, 91],
  ['TikTok', 'SP', 'Sorocaba', 6820, 0.937, 58],
  ['SHEIN', 'RJ', 'Rio de Janeiro', 16240, 0.898, 221],
  ['B2C', 'RJ', 'Duque de Caxias', 6100, 0.887, 94],
  ['SHEIN', 'MG', 'Belo Horizonte', 12840, 0.914, 138],
  ['TEMU', 'MG', 'Contagem', 6840, 0.901, 87],
  ['SHEIN', 'PR', 'Curitiba', 10420, 0.94, 73],
  ['SHEIN', 'BA', 'Salvador', 8260, 0.872, 146],
  ['TEMU', 'RS', 'Porto Alegre', 7840, 0.921, 69],
  ['TikTok', 'PE', 'Recife', 7160, 0.886, 101],
  ['B2C', 'GO', 'Goiânia', 6280, 0.907, 74],
  ['SHEIN', 'SC', 'Florianópolis', 5840, 0.932, 38],
  ['TEMU', 'CE', 'Fortaleza', 5620, 0.894, 82],
  ['SHEIN', 'DF', 'Brasília', 5180, 0.918, 51],
  ['B2C', 'AM', 'Manaus', 4320, 0.861, 88],
  ['SHEIN', 'PA', 'Belém', 3980, 0.874, 71]
];

// UF 汇总数据
export const ufNames = ['SP', 'RJ', 'MG', 'PR', 'BA', 'RS', 'PE', 'GO', 'SC', 'CE', '其他UF'];
export const ufVolumes = [148920, 28340, 19680, 14420, 12680, 11840, 10460, 9360, 8240, 7960, 46520];
export const ufRates = [93.1, 89.8, 91.4, 94.0, 87.2, 92.1, 88.6, 90.7, 93.2, 89.4, 88.9];
